import React from "react";
import Logo from "../../../components/Logo";
import chevron from "../../../assets/img/icons/table/Vector.svg";
import { Tooltip } from "antd";

export const Header = ({ isSidebarClosed, onClick, isClosed }) => {
  return (
    <div className="sidebar_header ">
      <Logo isSidebarClosed={isSidebarClosed} />
    </div>
  );
};

export const Toggle = ({ onClick, isClosed, mode }) => {
  return (
    <Tooltip
      placement={"top"}
      trigger="hover"
      mouseLeaveDelay={0}
      mouseEnterDelay={0.8}
      title={isClosed ? "Elargir le bandeau" : "Réduire le bandeau"}
    >
      <div
        className={`sidebar_toggle ${mode === "compta" ? "blue" : "yellow"}`}
        onClick={onClick}
      >
        <img
          src={chevron}
          alt="toggle"
          className={
            isClosed
              ? "sidebar-toggle-chevron sidebar-toggle-chevron--closed"
              : "sidebar-toggle-chevron sidebar-toggle-chevron--open"
          }
        />
      </div>
    </Tooltip>
  );
};
